import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'

import { IdentificationsMergeParamsSchemas } from 'schemas/identificationsSchemas'
import { IdentificationsMergeParamsTypes } from 'types/identifications'

export const useMemberIdentificationsMergeForm = ({
  defaultValues,
}: {
  defaultValues: IdentificationsMergeParamsTypes
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    watch,
  } = useForm<IdentificationsMergeParamsTypes>({
    resolver: zodResolver(IdentificationsMergeParamsSchemas),
    defaultValues,
  })

  return {
    handleSubmit,
    control,
    errors,
    setValue,
    reset,
    watch,
  }
}
